/**
 * Familux tenant — public API.
 *
 * Everything Familux-specific lives under this directory:
 *   - styles/familux.css        CSS overrides (gated via [data-tenant='familux'])
 *                               incl. @font-face for 'Familux Source Sans/Serif Pro'
 *                               and 'Familux Viktorie' — fonts live at
 *                               https://api.familux.com/assets/samera/{sans,serif,viktorie}/
 *                               (no vendoring in the bundle).
 *   - i18n/translations.ts      terms like "Pauschalen" → "Aktionswochen"
 *
 * Entry point: `applyFamilux()` is called by the tenant orchestrator
 * (`~tenants/tenant-overrides`) as soon as the active tenant is
 * 'familux'. Never import directly from components or shared code —
 * that's what the tenant API in `~tenants` is for.
 *
 * Note: there is NO Familux icon override anymore. Lucide icons
 * are used everywhere and pulled to the brand color via CSS
 * (`[data-tenant='familux'] svg { color: #383556 }`).
 */
import i18n from 'i18next';
import { familuxTranslations } from './i18n/translations';

export const applyFamilux = (): void => {
  Object.entries(familuxTranslations).forEach(([lng, namespaces]) => {
    Object.entries(namespaces).forEach(([ns, resources]) => {
      i18n.addResourceBundle(lng, ns, resources, true, true);
    });
  });
};
